import React from "react";


export default function DashboardBody({children}){
    return(
        <>
            {children}
        </>
    )
}